import { render, staticRenderFns } from "./rockiot.container.vue?vue&type=template&id=4573d744&"
import script from "./rockiot.container.vue?vue&type=script&lang=js&"
export * from "./rockiot.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports